export default "__VITE_ASSET__DWTYW6sd__"